module.exports = __webpack_public_path__ + "img/signed-tx.1f13c234.png";